// import React, { useState, useRef, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { HiDotsVertical, HiUser } from "react-icons/hi"; // npm install react-icons
// import { MdPrint, MdShare, MdDeleteOutline } from "react-icons/md";
// import styles from "./ActionMenu.module.css";
// import { useNavigate } from "react-router-dom";
// import { BiSolidUser, BiUserMinus } from "react-icons/bi";
// import { FaUserPlus } from "react-icons/fa";

// const ActionMenu = ({ item, handlePromoteAsAssociate }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const menuRef = useRef();
//   const navigate = useNavigate();

//   // Close menu when clicking outside

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <div className={styles.wrapper} ref={menuRef}>
//       <button
//         className={styles.trigger}
//         onClick={() => setIsOpen(!isOpen)}
//         aria-label="Actions"
//       >
//         <HiDotsVertical />
//         <AnimatePresence>
//           {isOpen && (
//             <motion.div
//               initial={{ opacity: 0, scale: 0.9, x: 10 }}
//               animate={{ opacity: 1, scale: 1, x: 0 }}
//               exit={{ opacity: 0, scale: 0.9, x: 10 }}
//               transition={{ duration: 0.15, ease: "easeOut" }}
//               className={styles.menu}
//             >
//               {/* The Arrow Pointer */}
//               <div className={styles.arrow} />

//               <button
//                 className={styles.menuItem}
//                 onClick={() =>
//                   navigate("/customers/customer-details", {
//                     state: {
//                       customerId: item?.CustomerID,
//                     },
//                   })
//                 }
//               >
//                 <HiUser className={styles.icon} />
//                 Profile
//               </button>
//               {item?.IsPromoted ? (
//                 <button className={`${styles.menuItem} bg-success-subtle`}>
//                   <FaUserPlus className={styles.icon} />
//                   Already Promoted
//                 </button>
//               ) : (
//                 <button
//                   className={styles.menuItem}
//                   onClick={handlePromoteAsAssociate}
//                 >
//                   <FaUserPlus className={styles.icon} />
//                   Promote as Associate
//                 </button>
//               )}

//               {/* <button
//                 className={styles.menuItem}
//                 onClick={() => handleClick("")}
//               >
//                 <MdShare className={styles.icon} />
//                 Share
//               </button> */}

//               {/* <div className={styles.divider} /> */}

//               {/* <button
//                 className={`${styles.menuItem} ${styles.delete}`}
//                 onClick={() => handleClick("")}
//               >
//                 <MdDeleteOutline className={styles.icon} />
//                 Delete
//               </button> */}
//             </motion.div>
//           )}
//         </AnimatePresence>
//       </button>
//     </div>
//   );
// };

// export default ActionMenu;

import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { HiDotsVertical, HiUser } from "react-icons/hi"; // npm install react-icons
import { MdPrint, MdShare, MdDeleteOutline } from "react-icons/md";
import styles from "./ActionMenu.module.css";
import { useNavigate } from "react-router-dom";
import { BiSolidUser, BiUserMinus } from "react-icons/bi";
import { FaUserPlus } from "react-icons/fa";
import { IoSettings } from "react-icons/io5";

const ActionMenu = ({ item, handlePromoteAsAssociate, i, CustomerType }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef();
  const navigate = useNavigate();

  // Close menu when clicking outside

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (menuRef.current && !menuRef.current.contains(event.target)) {
  //       setIsOpen(false);
  //     }
  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, []);

  return (
    <div className={styles.wrapper} ref={menuRef}>
      <button
        type="button"
        style={{ width: "60px", paddingTop: "6px", paddingBottom: "6px" }}
        class="btn d-flex align-items-center  justify-content-center btn-outline-info "
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Actions"
      >
        {i + 1}&nbsp;
        <i className=" d-inline-flex">
          <IoSettings />
        </i>
        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, scale: 0.9, x: 10 }}
              animate={{ opacity: 1, scale: 1, x: 0 }}
              exit={{ opacity: 0, scale: 0.9, x: 10 }}
              transition={{ duration: 0.15, ease: "easeOut" }}
              className={styles.menu}
            >
              {/* The Arrow Pointer */}
              <div className={styles.arrow} />

              <button
                className={styles.menuItem}
                onClick={() =>
                  navigate("/customers/customer-details", {
                    state: {
                      customerId: item?.CustomerID,
                    },
                  })
                }
              >
                <HiUser className={styles.icon} />
                Profile
              </button>
              {CustomerType != "Y" &&
                (item?.IsPromoted ? (
                  <button className={`${styles.menuItem} bg-success-subtle`}>
                    <FaUserPlus className={styles.icon} />
                    Already Promoted
                  </button>
                ) : (
                  <button
                    className={styles.menuItem}
                    onClick={handlePromoteAsAssociate}
                  >
                    <FaUserPlus className={styles.icon} />
                    Promote as Associate
                  </button>
                ))}

              {/* <button
                className={styles.menuItem}
                onClick={() => handleClick("")}
              >
                <MdShare className={styles.icon} />
                Share
              </button> */}

              {/* <div className={styles.divider} /> */}

              {/* <button
                className={`${styles.menuItem} ${styles.delete}`}
                onClick={() => handleClick("")}
              >
                <MdDeleteOutline className={styles.icon} />
                Delete
              </button> */}
            </motion.div>
          )}
        </AnimatePresence>
      </button>
    </div>
  );
};

export default ActionMenu;
